export default __webpack_public_path__ + "static/media/(57).d7c72ea8.jpg";